<template>
  <div id="app">
    <Header routeValue="2" ref="header"></Header>
    <content class="about_content" @click="handleDel()">
      <div class="banner_box">
        <div class="banner_content">
          A one-stop shop <br>
          for enterprises
        </div>
        <div class="banner_sub_content">
          Printbelle is where your creative inspiration takes off,<br>
          in the hands of your clients with no barriers between<br>
          your ideas and implementation.
        </div>
        <a @click="toDesign">
          <div class="contact">
            Get started
          </div>
        </a>
        <div class="banner_img">
          <img src="../assets/icon/about_bg.png">
        </div>
      </div>
      <div class="works_box">
        <div class="title">
          How Printbelle Works
          <div class="sub_title">
            Getting started is simple
          </div>
        </div>
        <div class="item_01">
            <div class="img_view"><img src="../assets/icon/about_item01.png"></div>
          <div class="text_wrap">
            <div class="content_title">Create Your account</div>
            <div class="content_subtitle">Sign up in minutes and connect to your online store, whether you use<br>
              Shopify, WooCommerce, or another platform.
            </div>
            <div class="content_button">
              <a @click="toSignUp">
                <div class="contact">
                  Sign up
                  <img src="../assets/icon/about_item_arrow.png" class="arrow">
                </div>
              </a>
            </div>
        </div>
        </div>
        <div class="item_02">
          <div class="text_wrap">
            <div class="content_title">Design & Sell</div>
            <div class="content_subtitle">Pick from our wide range of products and upload your designs. Once<br>
              they’re live, you’re ready to sell.
            </div>
            <div class="content_button">
              <a @click="toDesign">
                <div class="contact">
                  Start Designing
                  <img src="../assets/icon/about_item_arrow.png" class="arrow">
                </div>
              </a>
            </div>
          </div>
          <div class="img_view"><img src="../assets/icon/about_item02.png"></div>
        </div>
        <div class="item_03">
          <div class="img_view"><img src="../assets/icon/about_item03.png"></div>
          <div class="text_wrap">
            <div class="content_title">We Handle the Rest</div>
            <div class="content_subtitle">When an order comes in, we take care of everything—production,<br>
              packaging, and shipping straight to your customer.
            </div>
          </div>
        </div>
      </div>
      <div class="who_box">
        <span class="title">Who we are?</span>
        <span class="des">
          The Printbelle platform unites entrepreneurs with premier printing partners globally, fueling a new wave of eCommerce excellence.
          <br>Businesses created by regular individuals that bring happiness to numerous customers globally.
        </span>
        <div class="number_box">
          <div class="content_info">
            <div class="item_list">
              <div class="item">
                <span class="item_number">900+</span>
                <span class="item_underline" ></span>
                <span class="item_des">Custom products</span>
              </div>
              <div class="item"  style="margin-left: 105px">
                <span class="item_number">$2,000,000+</span>
                <span class="item_underline" ></span>
                <span class="item_des">Invested in printing equipment</span>
              </div>
              <div class="item" style="margin-left: 113px">
                <span class="item_number">2~5days</span>
                <span class="item_underline"></span>
                <span class="item_des">Fulfillment time</span>
              </div>
              <div class="item" style="margin-left: 107px">
                <span class="item_number">10,000,000+</span>
                <span class="item_underline"></span>
                <span class="item_des">Items fulfilled</span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="empowerment_box">
        <div class="green-section">
          <img src="@/assets/icon/about_empowerment.png" >
          <div class="text-content">
            <div class="title">No matter how big or small the<br>
              idea is, we can make it happen
            </div>
            <div class="des">
              All you need is creativity, and Printbelle will provide you with the<br>
              means to turn it into reality, You can use customized product options,<br>
              efficient printing and shipping processes, advanced design resources,<br>
              and industry-leading expertise.<br><br>
              The Printbelle team is full of passion and dedication. Whether in spirit<br>
              or in practice, everything we offer is based on high quality, reliability<br>
              and innovation. Whether it's a small or large order, Printbelle is your<br>
              trusted partner, committed to creating an excellent experience for you.
            </div>
          </div>
        </div>
      </div>
      <div class="quality_box">
        <div class="title">The Printbelle Quality Promise</div>
        <div class="cards-container">
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/about_card01.png" >
              <p class="image-overlay-text">High-quality Guarantee</p>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/about_card02.png" >
              <p class="image-overlay-text">Lightning-Fast Fulfillment</p>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/about_card03.png" >
              <p class="image-overlay-text">Exclusive Service</p>
            </div>
          </div>
          <div class="card">
            <div class="image-with-text">
              <img src="@/assets/icon/about_card04.png" >
              <p class="image-overlay-text">Continuous Improvement</p>
            </div>
          </div>
        </div>
      </div>
      <div class="service_box">
        <span class="title">We are at your service</span>
        <span class="des">For further cooperation, please fill in the information</span>
        <div class="from_box">
          <a-form-model
            style="margin-bottom: 55px"
            ref="form"
            :model="form"
            :rules="rules"
            slot="content"
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }">
            <a-form-model-item label="Name" prop="applyName">
              <a-input v-model="form.applyName" placeholder="Please enter your name" />
            </a-form-model-item>
            <a-form-model-item label="E-mail" prop="email">
              <a-input v-model="form.email" placeholder="Please enter your email address" />
            </a-form-model-item>
            <a-form-model-item label="Message" prop="remark">
              <a-textarea v-model="form.remark" placeholder="Please enter message"
                          :auto-size="{ minRows: 3, maxRows: 5 }" />
            </a-form-model-item>
          </a-form-model>
          <div class="business_box">
            <span class="business">Are you ready to start your own business with printbelle?</span>
            <div class="join_us" @click="submitForm">Join us</div>
          </div>

        </div>


      </div>

      <a-modal v-model="visible" :footer="null" @ok="handleOk" :width="560">
        <div>
          <div style="display: flex;align-items: center;justify-content: center;margin-top: 9px;margin-bottom: 21px">
            <img src="@/assets/succeed.png">
          </div>
          <p
            style="display: flex;flex-direction: column; width: 100%;line-height: 28px;font-size: 16px;color: #222222;text-align: center;align-items: center">
            <span>Thank you for reaching out. We will be in touch within 48 hours For</span>
            <span>urgent matters, please email us directly at  <a style="color: #2A79FA" :href="email">support@printbelle.com.</a></span>
            <span>Your patience is appreciated.</span>
          </p>
        </div>
      </a-modal>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import countTo from 'vue-count-to'
import {get, post} from '@/api'

export default {
  name: 'About',
  components: {
    Header,
    Footer,
    countTo
  },
  data () {
    return {
      visible: false,
      email: 'mailto:support@printbelle.com',
      skypeConfig: '',
      dataList: [],
      options: [],
      isLoading: false,
      form: {
        applyName: undefined,
        email: undefined,
        remark: undefined,
      },
      rules: {
        applyName: [{required: true, message: 'Please enter your name', trigger: 'blur'}],
        email: [
          {
            required: true,
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change']
          }
        ],
        remark: [{required: true, message: 'Please enter message', trigger: 'blur'}],
      },
      pageNum: 1,
      pageSize: 20
    }
  },
  mounted () {
    const hash = window.location.hash
    if (hash === '#step1') {
      window.scrollTo({
        top: 4050,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, 0)
    }
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    handleDel () {
      this.$refs.header.delProductValue()
    },
    getSkypeConfig () {
      this.skypeConfig = 'msteams://teams.microsoft.com/l/chat/0/0?users=luojiao@printbelle.com'
    },
    toDesign () {
      window.open(process.env.VUE_APP_MERCHANT + 'product/designer', '_blank')
    },
    toSignUp () {
      window.open(process.env.VUE_APP_MERCHANT + 'user/register', '_blank')
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          post('/index/apply', this.form)
            .then(response => {
              this.visible = true
            })
            .catch(error => {
              console.error(error)
            })
        } else {
          return false
        }
      })
    },
    toDetailsDes (item) {
      this.$router.push({path: `/designs/${item.id}`})
    },
    handleOk (e) {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">

.about_content {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  font-family: HarmonyOS Sans SC;

  .banner_box {
    height: 650px;
    position: relative;
    box-shadow: inset -20px 40px 20px -32px rgba(0, 0, 0, 0.07);
    //margin-top: 72px;
    overflow: hidden;
    background: #F4F4F4;



    .banner_content {
      position: absolute;
      top: 127px;
      left: 319px;
      width: 482px;
      height: 124px;



      font-weight: 900;
      font-size: 60px;
      color: #111111;
      line-height: 64px;
    }

    .banner_sub_content {
      position: absolute;
      top: 307px;
      left: 319px;

      font-weight: 400;
      font-size: 18px;
      color: #222222;
      line-height: 30px;
    }

    .contact {
      position: absolute;
      top: 465px;
      left: 320px;

      padding-left: 34px;
      font-weight: bold;
      font-size: 20px;
      color: #222222;
      width: 183px;
      height: 57px;
      line-height: 57px;
      cursor: pointer;
      background: #C5FAFF;
      border-radius: 3px;

    }
    .banner_img {
      position: absolute;
      left: 961px;
      width: 959px;
      height: 650px;
    }
  }

  .works_box {
    background: #ffffff;
    padding-top: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-weight: 900;
      font-size: 55px;
      color: #111111;
      line-height: 60px;

      .sub_title {
        height: 19px;
        margin-top: 17px;
        font-weight: 400;
        font-size: 18px;
        color: #888A96;
        line-height: 30px;
        padding-left: 190px;
      }
    }

    .item_01 {
      margin: 70px auto 0;
      width: 1281px;
      display: flex;
      flex-wrap: nowrap;

      .img_view {
      }

      .text_wrap {
        flex: 1;
        margin-left: 57px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .content_title {
          font-weight: 900;
          font-size: 40px;
          color: #111111;
          line-height: 48px;
        }

        .content_subtitle {
          margin-top: 20px;
          font-weight: 500;
          font-size: 18px;
          color: #111111;
          line-height: 30px;
          width: 579px;

        }

        .content_button {
          margin-top: 45px;
          width: 151px;
          height: 49px;
          background: #012169;
          border-radius: 7px;
          display: flex;
          align-items: center;
          justify-content: center;

          .contact {
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            display: flex;
            align-items: center;
          }

          .arrow {
            object-fit: contain;
            margin-left: 8px;
            animation: slide-right 2s infinite;
          }
        }
      }
    }

    .item_02 {
      height: 402px;
      width: 1281px;
      display: flex;
      flex-wrap: nowrap;

      .img_view {
        margin-top: 189px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .text_wrap {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .content_title {
          margin-top: 140px;
          font-weight: 900;
          font-size: 40px;
          color: #111111;
          line-height: 48px;
          width: 270px;
        }

        .content_subtitle {
          margin-top: 20px;
          font-weight: 400;
          font-size: 18px;
          color: #111111;;
          line-height: 30px;
          width: 579px;
        }

        .content_button {
          margin-top: 45px;
          width: 208px;
          height: 49px;
          background: #012169;
          border-radius: 7px;

          .contact {
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            padding-left: 22px;
            color: #FFFFFF;
            margin-top: 10px;

            .arrow {
              object-fit: contain;
              margin-left: 8px;
              animation: slide-right 2s infinite;
            }
          }
        }
      }
    }

    .item_03 {
      margin: 189px auto 122px;
      width: 1281px;
      display: flex;
      flex-wrap: nowrap;

      .img_view {
      }

      .text_wrap {
        flex: 1;
        margin-left: 57px;
        display: flex;
        flex-direction: column;
        justify-content: center;


        .content_title {
          left: 711px;
          font-weight: 900;
          font-size: 40px;
          color: #111111;
          line-height: 48px;
        }

        .content_subtitle {
          left: 711px;
          margin-top: 20px;
          font-weight: 500;
          font-size: 18px;
          color: #111111;
          line-height: 30px;
        }
      }
    }
  }

  .who_box {
    background: #EFEFEF;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 585px;

    .title {
      z-index: 1;
      font-weight: 900;
      font-size: 55px;
      color: #111111;
      line-height: 45px;
      margin-top: 90px;
      //margin-bottom: 40px;
    }

    .des {
      z-index: 1;
      font-weight: 400;
      font-size: 20px;
      color: #888A96;
      text-align: center;
      line-height: 30px;
      margin-top: 35px;
      margin-bottom: 12px;
    }

    .number_box {
      background: #C5FAFF;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 61px 0 0 0;
      width: 100%;

      .content_info {
        z-index: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 400px;
        margin-top: -180px;
        margin-bottom: 60px;
        display: flex;
        align-items: center;
        justify-items: center;
        flex-direction: column;

        .item_list {
          position: relative;
          top: 258px;
          width: 1261px;
          display: flex;
          background: #C5FAFF;

          .item {
            display: flex;
            flex-direction: column;


            .item_number {
              font-weight: 900;
              font-size: 50px;
              color: #111111;
              line-height: 48px;

            }
            .item_underline {
              height: 3px;
              background-color: #111111;
              margin: 30px 0 20px;
              width: 137px;
            }

            .item_des {
              font-weight: 400;
              font-size: 18px;
              color: #111111;
              line-height: 48px;
              white-space: nowrap;
            }
          }
        }
      }

    }
  }


  .empowerment_box {
    margin: 0 auto;
    padding: 125px;

    .green-section {
      display: flex;
      align-items: center;
      background-color: #0B550F;
      width: 1261px;
      height: 508px;
      margin: 0 auto;
      padding: 20px;
    }

    .green-section img {
      width: 484px;
      height: 531px;
      margin-top: 135px;
      margin-left: 61px;

    }

    .text-content {
      margin-left: 76px;
      margin-top: -13px;

      .title {
        font-weight: bold;
        font-size: 38px;
        color: #FFFFFF;
        line-height: 50px;
      }

      .des {
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 28px;
        margin-top: 26px;
      }
    }
  }

  .quality_box{
    width: 1281px;
    margin: 70px auto ;
    text-align: center;
    .title {
      font-weight: 900;
      font-size: 55px;
      color: #111111;
    }
  }

  .cards-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 46px;
  }
  .card {}
  .image-with-text {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .image-with-text img {
    display: block;
    margin-bottom: 0;
  }
  .image-overlay-text {
    position: absolute;
    bottom: 23px;
    left: 0;
    right: 0;
    font-weight: bold;
    font-size: 20px;
    color: #111111;
  }

  .service_box {
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 105px;

    .title {
      font-weight: 900;
      font-size: 55px;
      color: #111111;
    }

    .des {
      font-weight: 400;
      font-size: 20px;
      color: #888A96;
      line-height: 30px;
    }

    .from_box {
      width: 1899px;
      height: 450px;
      margin-top: 5px;
      padding-left: 300px;
      padding-top: 30px;
      border-radius: 20px;
      position: relative;


      /deep/ .ant-form label {
        font-size: 20px;
        font-weight: 400;
        color: #111111;
      }

      /deep/ .ant-row {
        position: relative;
        height: auto;
        margin-right: 0;
        margin-left: -0px;
        margin-bottom: 32px;
        zoom: 1;
        display: block;
        box-sizing: border-box;
      }
      /deep/ .ant-input {
        height: 59px;
        width: 828px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #D2D2D2;
        font-weight: 400;
        font-size: 20px;
        color: #D2D2D2;
      }

      .business_box {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: -50px;
        top: 382px;

        .business {
          font-weight: 500;
          font-size: 26px;
          color: #111111;
          margin-left: 320px;

        }

        .join_us {
          width: 262px;
          height: 53px;
          text-align: center;
          background: #012169;
          border-radius: 7px;
          font-size: 30px;
          margin-top: 35px;
          margin-left: 525px;
          line-height: 53px;
          cursor: pointer;
          font-weight: 900;
          color: #FFFFFF;
        }
      }


    }

  }


  @keyframes slide-right {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(50%);
    }
    100% {
      transform: translateX(0);
    }
  }

}

/deep/ .ant-modal-close-x {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue